import EmptyStateEnhanced from './EmptyStateEnhanced';

export default EmptyStateEnhanced; 